/**
 * @format
 * @flow
 */
export const LOAD_START = 'LOAD_START';
export const LOAD_END = 'LOAD_END';
export const MODAL_CHANGE = 'MODAL_CHANGE';
export const ERROR_SHOW = 'ERROR_SHOW';
export const ERROR_RESET = 'ERROR_RESET';
export const SET_NOTIFICATION_DATA = 'SET_NOTIFICATION_DATA';
